module.exports = __webpack_public_path__ + "img/6-8.24f8f6d2.png";